import { request } from './client';

export function listCategories({ filter = {}, sort = {} } = {}) {
  return request('/api/category/v1/categories/list', {
    method: 'POST',
    body: JSON.stringify({ filter, sort }),
  });
}
